import {PlayerMix, PlayerProgram} from "@splixer/player";
import {Pv2ContentMenuItem} from "./menu-item.interface";
import {uBoolean} from "@hidat/huijs-interfaces";
import {FlatBrandedContent} from "../../models";

export interface Pv2MenuConverterConfig {
  displayPlayButtons?: uBoolean;
  displayTagLines?: uBoolean;
  displayHostName?: uBoolean;
  baseRoute?: string [] | undefined;
  includeBackgroundImage?: uBoolean;
}

/**
 * Converts an array of Mixes to Content Menu Items, so they can be used for playable menu lists
 * @param items
 */
export function mixesToMenuItems(items: PlayerMix [], config: Pv2MenuConverterConfig = {}): Pv2ContentMenuItem[] {
  const menuItems: Pv2ContentMenuItem [] = [];
  if (items) {
    for (const item of items) {
      if (item.uid) {
        const mi: Pv2ContentMenuItem = {
          id: item.uid,
          name: item.name ?? 'No Name!',
          duration: item.duration
        }
        if (config.displayPlayButtons) {
          mi.contentId = item.uid;
        }
        if (config.displayTagLines) {
          mi.tagLine = item.tagLine;
        }
        if (config.baseRoute) {
          mi.routerLink = [...config.baseRoute, item.uid];
        }
        menuItems.push(mi);
      }
    }
  }
  return menuItems;
}

/**
 * Converts an array of Mixes to Content Menu Items, so they can be used for playable menu lists
 * @param items
 */
export function programToMenuItems(items: PlayerProgram [], config: Pv2MenuConverterConfig = {}): Pv2ContentMenuItem[] {
  const menuItems: Pv2ContentMenuItem [] = [];
  if (items) {
    for (const item of items) {
      if (item.id) {
        const mi: Pv2ContentMenuItem = {
          id: item.id.toString(),
          name: item.name ?? 'No Name!',
        }
        if (config.displayPlayButtons) {
          if (item._lastShowMix) {
            mi.contentId = item._lastShowMix.uid;
            mi.title = item._lastShowMix.tagLine;
          }
        }
        if (config.displayTagLines) {
          mi.tagLine = item.tagLine;
        }
        if (config.displayHostName && item._host?.name) {
          mi.thirdLine = 'Hosted by ' + item._host.name;
        }
        if (config.baseRoute) {
          mi.routerLink = [...config.baseRoute, item.id.toString()];
        }
        if (config.includeBackgroundImage) {
          mi.backgroundImage = item.branding.avatarImageUrl;
        }
        menuItems.push(mi);
      }
    }
  }
  return menuItems;
}

/**
 * Converts an array of Mixes to Content Menu Items, so they can be used for playable menu lists
 * @param items
 */
export function flatBrandedContentToMenuItems(items: FlatBrandedContent [], config: Pv2MenuConverterConfig = {}): Pv2ContentMenuItem[] {
  const menuItems: Pv2ContentMenuItem [] = [];
  if (items) {
    for (const item of items) {
      if (item.id) {
        const mi: Pv2ContentMenuItem = {
          id: item.id,
          name: item.name ?? 'No Name!',
        }
        if (config.displayPlayButtons) {
            mi.contentId = item.contentId;
            mi.title = item.tagLine;
          }
        if (config.displayTagLines) {
          mi.tagLine = item.tagLine;
        }
        if (config.displayHostName && item.hostName) {
          mi.thirdLine = 'Hosted by ' + item.hostName;
        }
        if (config.baseRoute) {
          mi.routerLink = [...config.baseRoute, item.id.toString()];
        }
        if (config.includeBackgroundImage) {
          mi.backgroundImage = item.avatarImageUrl;
        }
        menuItems.push(mi);
      }
    }
  }
  return menuItems;
}

